// extracted by mini-css-extract-plugin
export const joinTheMovementSection = "joinTheMovementSection-module--joinTheMovementSection--2lvg5";
export const sectionContainer = "joinTheMovementSection-module--sectionContainer--1soYn";
export const headingWrap = "joinTheMovementSection-module--headingWrap--2Fcnp";
export const owlWrap = "joinTheMovementSection-module--owlWrap--3Xja1";
export const listingItem = "joinTheMovementSection-module--listingItem--1AMfo";
export const sectionDescWrap = "joinTheMovementSection-module--sectionDescWrap--3cSm1";
export const sectionDesc = "joinTheMovementSection-module--sectionDesc--2u-hh";